import './ECatalogs.scss';

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import Slider from 'react-slick';

import { BREAKPOINTS, NEXT, PREV, ROUTE_ECATALOGS } from '@/common/constants';
import Item from '@/ebat/components/blocks/Cms/ECatalogs/Item/Item';
import CustomArrow from '@/ebat/components/blocks/Common/Slider/CustomArrow/CustomArrow';
import { HOME_ECATALOGS_FORMATS } from '@/ebat/constants';
import useECatalogs from '@/ebat/queries/e-catalogs/useECatalogs';

const ECatalogs = () => {
  const { t } = useTranslation();

  const { data: eCatalogs, isSuccess } = useECatalogs({ limit: 15 });

  const sliderSettings = useMemo(
    () => ({
      slidesToShow: 5,
      infinite: eCatalogs && eCatalogs.data && eCatalogs.data.length > 4,
      dots: false,
      arrows: true,
      prevArrow: <CustomArrow type={PREV} />,
      nextArrow: <CustomArrow type={NEXT} />,
      responsive: [
        {
          breakpoint: BREAKPOINTS.full,
          settings: {
            slidesToShow: 5,
            infinite: false,
          },
        },
        {
          breakpoint: BREAKPOINTS.large,
          settings: {
            slidesToShow: 4,
            infinite: false,
          },
        },
        {
          breakpoint: BREAKPOINTS.desktop - 1,
          settings: {
            slidesToShow: 2.5,
            infinite: false,
          },
        },
        {
          breakpoint: BREAKPOINTS.tablet - 1,
          settings: {
            slidesToShow: 1.5,
            infinite: false,
            arrows: false,
          },
        },
      ],
    }),
    [eCatalogs],
  );

  return (
    <div className="page-home__catalogs" data-qa-id="home-catalogs">
      <div className="wrapper">
        <div className="title">
          <h2 className="h2">{t('ebat:entities:home.ecatalogs.title')}</h2>
          <NavLink className="more" to={ROUTE_ECATALOGS}>
            {t('common:messages:actions.see_all')}
          </NavLink>
        </div>
        {isSuccess && (
          <Slider
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...sliderSettings}
            className="catalogs"
            data-qa-id="catalogs"
          >
            {eCatalogs.data.map((catalog) => (
              <Item
                key={`catalog-${catalog.id}`}
                color={catalog.color}
                formats={HOME_ECATALOGS_FORMATS}
                id={catalog.id}
                images={catalog.images}
                linkPdf={`${ROUTE_ECATALOGS}/${catalog.id}`}
                name={catalog.name}
                isHomePage
              />
            ))}
          </Slider>
        )}
      </div>
    </div>
  );
};

export default ECatalogs;
